import { createTypes } from "reduxsauce";

export default createTypes(
    `
    SUBMIT_ORDER_ID_YARD_VISIT_INIT
    SUBMIT_ORDER_ID_YARD_SUCCESS
    SUBMIT_ORDER_ID_YARD_VISIT_FAILURE
    SUBMIT_WALK_IN_YARD_VISIT_INIT
    SUBMIT_WALK_IN_YARD_VISIT_SUCCESS
    SUBMIT_WALK_IN_YARD_VISIT_FAILURE
    CONFIRM_EMAIL_INIT
    CONFIRM_EMAIL_SUCCESS
    CONFIRM_EMAIL_FAILURE
    UPDATE_ORDER_ID_INPUT
    SET_YARD_CONFIRMATION_MESSAGE
`,
    {
        prefix: "yardVisitForm/"
    }
);
